document.addEventListener('DOMContentLoaded', (event) => {
    const stickyATC = document.querySelector('#sticky-atc');
    const threshold = document.querySelector('button[name="add"]').getBoundingClientRect().bottom + Number(stickyATC.dataset.offset);
    const mainFormButton = document.querySelector('.product-form__submit');
    const stickyATCButton = document.querySelector('.sticky-product__button');
    const stickyATCCustomilyButton = document.querySelector('.sticky-customize-button');
    window.addEventListener('scroll', () => {
        if (window.scrollY > threshold) {
            stickyATC.classList.add('show');
            document.documentElement.style.paddingBottom = `${stickyATC.clientHeight}px`;
            document.documentElement.style.height = 'auto';
        } else {
            stickyATC.classList.remove('show');
            document.documentElement.style.paddingBottom = '0';
        }
    });
    // Sticky Button click Main Button
    if(stickyATCButton){
        stickyATCButton.addEventListener("click", function() {
            mainFormButton.click();
        });
    }
    // Customily container addition check
    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                for (const node of mutation.addedNodes) {
                    if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'DIV') {
                        if (node.classList.contains('customily-modal-container')) {
                            const customilyButton = document.querySelector('.customily-personalize-button');
                            stickyATCButton.classList.add('hidden-cart-btn');
                            stickyATCCustomilyButton.classList.remove('hidden-cart-btn');
                            stickyATCCustomilyButton.addEventListener("click", function() {
                                customilyButton.click();
                            });
                        }
                    }
                }
            }
        }
    });
    observer.observe(document.body, { childList: true });
});